import React from "react"
import { graphql } from "gatsby"
//import { StaticImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

// Import Swiper React components
import { A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

// We're using Gutenberg so we need the block styles
// these are copied into this project due to a conflict in the postCSS
// version used by the Gatsby and @wordpress packages that causes build
// failures.
// @todo update this once @wordpress upgrades their postcss version
import "../css/@wordpress/block-library/build-style/style.css"
import "../css/@wordpress/block-library/build-style/theme.css"

//import Bio from "../components/bio"
// import Layout from "../components/layout"
import Seo from "../components/seo"
import FeaturedArticle from "../components/featured-article"
import ShareButtons from "../components/share-buttons"

import { useLocation } from "@reach/router"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

const BlogPostTemplate = ({ data: { post } }) => {
  const featuredImage = {
    sourceUrl: post.featuredImage?.node?.sourceUrl,
    alt: post.featuredImage?.node?.alt || ``,
  }

  const location = useLocation()

  const image = getImage(post.featuredImage?.node?.gatsbyImage)

  const tags = post.tags.nodes

  return (
    <div>
      <Seo
        title={post.title}
        description={post.excerpt}
        yoast={post.seo.fullHead}
        schema={post.seo.schema.raw}
      />

      <section className="py-5 container">
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2 text-center">
            <div className="alert alert-danger" role="alert">
              Subscribe to our&nbsp;
              <a
                href="https://t.me/misstamchiak"
                target="_blank"
                rel="noreferrer"
              >
                Telegram
              </a>
              &nbsp;channel to receive latest news
            </div>
          </div>
          <div className="col-12 col-lg-8 offset-lg-2 text-center">
            <h1 className="title">{parse(post.title + "")}</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6 offset-lg-3 mb-5">
            <div class="d-flex align-items-center">
              <div>
                <img
                  alt={post.author?.node.name || ``}
                  className="img_profile"
                  src={post.author.node.avatar.url}
                />
              </div>
              <div>
                {post.author.node.name}
                <br />
                {post.date}
                <br />
                <ShareButtons
                  url={location.href}
                  title={post.title}
                  description={post.excerpt.replace(/(<([^>]+)>)/gi, "")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-3 gx-lg-5">
            {/* 
            <p>
              <StaticImage
                src="../images/advert_vertical.jpg"
                formats={["AUTO", "WEBP"]}
                alt=""
                className="img-fluid"
              />
            </p>
            <p>
              <StaticImage
                src="../images/advert_vertical.jpg"
                formats={["AUTO", "WEBP"]}
                alt=""
                className="img-fluid"
              />
            </p>
            */}
          </div>
          <div className="col-12 col-lg-7 mb-10">
            {/* if we have a featured image for this post let's display it */}
            {featuredImage?.sourceUrl && (
              // <GatsbyImage image={getImage(image)} alt={featuredImage.alt} />
              <img
                alt={featuredImage?.alt}
                className="img_thumbnail"
                src={featuredImage?.sourceUrl}
                layout="fullWidth"
                formats={["auto", "webp", "avif"]}
              />
            )}

            {!!post.content && <section>{parse(post.content + "")}</section>}
            {/* <section>
              Tags:
              {
                tags.map((tag, i)=>(
                  <u>{tag.name}</u>
                ))
              }
            </section> */}
          </div>
        </div>

        <div id="responsive-mid1" className="advert"></div>

        <div className="row mt-10">
          <div className="col-12">
            <div className="heading">You may also like</div>
          </div>
          <div className="col">
            <Swiper
              modules={[A11y]}
              loop={false}
              spaceBetween={20}
              slidesPerView={1.1}
              breakpoints={{
                768: {
                  slidesPerView: 2.2,
                },
                1024: {
                  slidesPerView: 3.3,
                  spaceBetween: 25,
                },
              }}
              onSwiper={swiper => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
              className="h-100"
            >
              {post.relatedPosts?.nodes.map(
                ({ uri, featuredImage, title, excerpt }) => {
                  const image_url = {
                    sourceUrl: featuredImage?.node?.sourceUrl,
                    alt: featuredImage?.node?.alt || ``,
                  }
                  return (
                    <SwiperSlide>
                      <FeaturedArticle
                        url={uri}
                        gatsbyImage={featuredImage?.node?.gatsbyImage}
                        image={image_url}
                        name={title}
                        lead_in={excerpt}
                      />
                    </SwiperSlide>
                  )
                }
              )}
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostById(
    $id: String!
  ) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      uri
      date(formatString: "MMMM DD, YYYY")
      seo {
        fullHead
        schema {
          raw
        }
      }
      author {
        node {
          name
          avatar {
            url
          }
        }
      }
      tags{
        nodes {
          slug
          name
        }
      }
      featuredImage {
        node {
          altText
          sourceUrl
          gatsbyImage(width: 800)
        }
      }
      relatedPosts {
        nodes {
          excerpt
          title
          uri
          featuredImage {
            node {
              altText
              sourceUrl
              gatsbyImage(width: 800)
            }
          }
        }
      }
    }
  }
`
